import { BRAND_NAME, BILLING_NAME } from "@/config";

const LINKS = [
  { label: "Terms", href: "/terms.html" },
  { label: "Privacy", href: "/privacy.html" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-navy/8 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-1.5">
            <img src="/slammed-icon.png?v=5" alt={`${BRAND_NAME} logo`} width="28" height="28" className="h-7 w-7 object-contain" />
            <span className="font-display text-xl font-extrabold tracking-tight text-gradient">{BRAND_NAME}</span>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="font-sans text-sm text-navy/55 transition-colors hover:text-brand-indigo"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-8 border-t border-navy/8 pt-6">
          <p className="max-w-2xl text-xs leading-relaxed text-navy/45">
            Payments are securely processed and billed as{" "}
            <span className="font-medium text-navy/60">{BILLING_NAME}</span>.
          </p>
          <p className="mt-2 text-xs text-navy/40">
            © {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
